import { isProviderSeatRole } from '@constants/Providers'
import { Provider } from '@dataTypes/provider.types'
import {
  formatProviderDisplayName,
  isHygienistWorkRole,
} from '@utils/provider-display.utils'

export const isProviderSeatRoleExcludingHygienist = (
  workRole: string | undefined,
): boolean => isProviderSeatRole(workRole) && !isHygienistWorkRole(workRole)

export const belongsToClinic = (
  provider: Provider,
  clinicId: string,
): boolean =>
  provider.clinic_id === clinicId ||
  Boolean(
    provider.assigned_clinics?.some((clinic) => clinic.clinic_id === clinicId),
  )

export const buildProviderSearchList = (
  providers: Provider[],
  clinicId: string | undefined,
): { id: string; name: string }[] => {
  if (!clinicId) {
    return []
  }
  return providers
    .filter(
      (provider) =>
        isProviderSeatRoleExcludingHygienist(provider.work_role) &&
        belongsToClinic(provider, clinicId),
    )
    .map((provider) => ({
      id: provider.provider_id,
      name: formatProviderDisplayName(provider),
    }))
}

export const resolveChartProviderDisplayName = (
  provider: Parameters<typeof formatProviderDisplayName>[0],
  providerId: string | undefined,
  providerSearchList: { id: string; name: string }[],
): string => {
  const nestedName = formatProviderDisplayName(provider, '')
  if (nestedName) {
    return nestedName
  }
  if (!providerId) {
    return '-'
  }
  return providerSearchList.find((item) => item.id === providerId)?.name ?? '-'
}
